import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/User";
import hermesAPIConfig from "./modules/HermesAPIConfig";
import diceAPIConfig from "./modules/DiceAPIConfig";
import currencies from "./modules/Currencies";
import countries from "./modules/Countries";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: { user, hermesAPIConfig, diceAPIConfig, currencies, countries },
});